/* eslint-disable no-undef, camelcase */

const signalviewConfig =
    typeof window !== 'undefined' && window.signalviewConfig ? window.signalviewConfig : {};
const staticRoot =
    typeof signalviewConfig.staticRoot === 'string' ? signalviewConfig.staticRoot : '';

__webpack_public_path__ = staticRoot && !staticRoot.endsWith('/') ? `${staticRoot}/` : staticRoot;
